import { marked } from 'marked'
import DOMPurify from 'dompurify'

// breaks: true → a single newline becomes <br>, so the model's line-separated
// output (e.g. "Role: …\nIncident Date: …") renders as distinct lines instead
// of being collapsed into one paragraph.
marked.setOptions({ gfm: true, breaks: true })

/** Model output → safe HTML. No raw HTML/script survives sanitization. */
export function renderMarkdown(md: string): string {
  const raw = marked.parse(md, { async: false }) as string
  return DOMPurify.sanitize(raw, { USE_PROFILES: { html: true } })
}
